var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWarning = function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F73A54",
    fillRule: "evenodd",
    d: "M13.73 1.994c-.77-1.33-2.69-1.33-3.46 0L1.003 17.998C.232 19.33 1.194 21 2.734 21h18.532c1.54 0 2.502-1.669 1.73-3.002zM2.735 19 12 2.996 21.266 19zM13 7v6h-2V7zm0 8.5v.5a1 1 0 1 1-2 0v-.5a1 1 0 1 1 2 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconWarning;